import React, { useState } from 'react';
import './LearningsPredictions.css';

function LearningsPredictions() {
  const [predictions] = useState([
    {
      tag: 'Research',
      text: 'Brain-computer interfaces with EEG and machine learning',
      details:
        'Use signal processing and machine learning to better read mental states and build more responsive feedback systems.',
    },
    {
      tag: 'Neurotech',
      text: 'Brain stimulation studies with tDCS and tACS',
      details:
        'Explore how different stimulation methods affect cognition, perception and experimental work around sleep and consciousness.',
    },
    {
      tag: 'Mobile',
      text: 'Stronger mobile product development',
      details:
        'Deepen React Native and native mobile work to bring these ideas into more practical and daily-use formats.',
    },
  ]);

  return (
    <section className="portfolio-section learnings-predictions" id="goals">
      <div className="section-heading">
        <span className="section-kicker">Goals</span>
        <h2 className="section-title">Current directions.</h2>
        <p className="section-description">
          The next steps stay close to neuroscience, embedded systems and
          product execution.
        </p>
      </div>

      <div className="predictions-list">
        {predictions.map((prediction, index) => (
          <article key={prediction.text} className="prediction-item">
            <div className="prediction-head">
              <span className="prediction-index">
                {String(index + 1).padStart(2, '0')}
              </span>
              <span className="prediction-tag">{prediction.tag}</span>
            </div>
            <h3>{prediction.text}</h3>
            <p>{prediction.details}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default LearningsPredictions;
